import React from 'react';
import { Outlet } from "react-router";

const FunnelLayout = () => {
    return (
        <Outlet />
    );
};

export default FunnelLayout;